import { LogOut } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../auth'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tendbot/ui'

interface Props {
  open: boolean
  onClose: () => void
}

export default function SignOutConfirmModal({ open, onClose }: Props) {
  const { t } = useTranslation('settings')
  const { signOut } = useAuth()

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose() }}>
      <DialogContent accent="rose">
        <div className="flex justify-center mb-4">
          <div className="w-14 h-14 rounded-full bg-rose/10 border border-rose/20 grid place-items-center">
            <LogOut size={26} className="text-rose" />
          </div>
        </div>
        <DialogHeader>
          <DialogTitle>{t('signOutModal.title')}</DialogTitle>
          <DialogDescription>{t('signOutModal.description')}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-6 gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-xl bg-slate-mid/50 border border-slate-mid text-pearl font-medium text-sm hover:bg-slate-mid/80 transition-colors"
          >
            {t('signOutModal.cancel')}
          </button>
          <button
            onClick={() => void signOut()}
            className="flex-1 py-3 rounded-xl bg-rose/80 text-white font-semibold text-sm hover:bg-rose transition-colors flex items-center justify-center gap-2"
          >
            <LogOut size={16} />
            {t('signOutModal.confirm')}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
